// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button {
  padding: var(--spacing-tiny) var(--spacing-meduim);
  border-radius: var(--border-radius-base);
  border: var(--border-solid);
  gap: var(--spacing-small);
  transition:
    background-color 0.3s ease-in-out,
    color 0.3s ease-in-out;
  cursor: pointer;
  touch-action: manipulation;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}

.button-label {
  font-size: var(--font-size-base);
  font-weight: 300;
}

.button-icon {
  width: 22px;
  height: 22px;
}

.button:active {
  box-shadow: var(--box-shadow-button);
}

.theme-button,
.holiday-button {
  position: relative;
  padding: var(--spacing-tiny);
  transition:
    background-color 0.3s ease-in-out,
    color 0.3s ease-in-out;
}

.theme-button svg path {
  transition:
    fill 0.3s ease-in-out,
    color 0.3s ease-in-out;
}

@media (hover: none) {
  .button:hover {
    background: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/base/button.css"],"names":[],"mappings":"AAAA;EACE,kDAAkD;EAClD,wCAAwC;EACxC,2BAA2B;EAC3B,yBAAyB;EACzB;;0BAEwB;EACxB,eAAe;EACf,0BAA0B;EAC1B,yBAAiB;KAAjB,sBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,kBAAkB;EAClB,4BAA4B;EAC5B;;0BAEwB;AAC1B;;AAEA;EACE;;0BAEwB;AAC1B;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".button {\n  padding: var(--spacing-tiny) var(--spacing-meduim);\n  border-radius: var(--border-radius-base);\n  border: var(--border-solid);\n  gap: var(--spacing-small);\n  transition:\n    background-color 0.3s ease-in-out,\n    color 0.3s ease-in-out;\n  cursor: pointer;\n  touch-action: manipulation;\n  user-select: none;\n}\n\n.button-label {\n  font-size: var(--font-size-base);\n  font-weight: 300;\n}\n\n.button-icon {\n  width: 22px;\n  height: 22px;\n}\n\n.button:active {\n  box-shadow: var(--box-shadow-button);\n}\n\n.theme-button,\n.holiday-button {\n  position: relative;\n  padding: var(--spacing-tiny);\n  transition:\n    background-color 0.3s ease-in-out,\n    color 0.3s ease-in-out;\n}\n\n.theme-button svg path {\n  transition:\n    fill 0.3s ease-in-out,\n    color 0.3s ease-in-out;\n}\n\n@media (hover: none) {\n  .button:hover {\n    background: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
